import React, { useEffect, useState } from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";

import L from "leaflet";

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export interface MapComponentProps {
  center?: number[];
  zoom?: number;
  scrollWheelZoom?: false;
  style?: React.CSSProperties;
  pinList?: { position: number[]; name: string }[];
}

// MapContainer treats center/zoom as immutable initial props; this child
// imperatively re-centers when the caller's center/zoom change.
function RecenterOnChange({ center, zoom }: { center?: number[]; zoom?: number }) {
  const map = useMap();
  const lat = center?.[0];
  const lng = center?.[1];
  useEffect(() => {
    if (center && center.length === 2 && zoom !== undefined) {
      map.setView(center as [number, number], zoom);
    }
  }, [lat, lng, zoom, map, center]);
  return null;
}

const MapComponent = ({ pinList, style, center, zoom = 13 }: MapComponentProps) => {
  const [pointsOfInterest, setPointsOfInterest] = useState([{ position: [0, 0], name: "aucune location" }]);

  useEffect(() => {
    if (pinList) setPointsOfInterest(pinList);
  }, [pinList]);

  return (
    <>
      <MapContainer center={center as any} zoom={zoom} style={style}>
        <RecenterOnChange center={center} zoom={zoom} />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {pointsOfInterest &&
          pointsOfInterest.map((point, index) => (
            <Marker key={index} position={point.position as any}>
              <Popup>{point.name}</Popup>
            </Marker>
          ))}
      </MapContainer>
    </>
  );
};

export default MapComponent;
